"use client";
import { useWindowSize } from "@uidotdev/usehooks";
import {
  motion,
  useScroll,
  useSpring,
  useTransform,
  MotionValue,
} from "framer-motion";

function useParallax(value: MotionValue<number>, distance: number) {
  const v = useTransform(value, [0, 1], [-distance, 0]);
  return useSpring(v, { stiffness: 150, damping: 50, bounce: 0, mass: 0.5 });
}

const ParallaxBackground = ({className = "background-lv"}) => {
  const { height } = useWindowSize();
  const { scrollYProgress } = useScroll();
  const y = useParallax(scrollYProgress, height || 0);
  return (
    <div className={`${className} fixed`}>
      <motion.div initial={{ y: -(height || 0) }} style={{ y }}></motion.div>
    </div>
  );
};

export default ParallaxBackground;
